import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import ImageWithBasePath from "core/img/imagewithbasebath";
import {
  Edit,
  PlusCircle,
  Trash2,
} from "feather-icons-react/build/IconComponents";
import { Download, Eye, Upload, Users } from "react-feather";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { format } from "date-fns";
import Error404 from "MainPages/ErrorPages/error404";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import useTableExport from "core/Operations/useTableExport";
import { Spin, Table } from "antd";
const EmployeeMaster = () => {
  const userData = useSelector(loggedInUser);
  const route = all_routes;

  // const [searchParams] = useSearchParams();
  // console.log("searchParams", searchParams.get("residentialType"));

  const [queryParams, setQueryParams] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      groupCode: params.get("groupCode") || "",
      residentialType: params.get("residentialType") || "",
      departmentCode: params.get("departmentCode") || 0,
      gender: params.get("gender") || "",
      nationality: params.get("nationality") || "",
      employmentType: params.get("employmentType") || "",
      employeeType: params.get("employeeType") || "",
    };
  });

  const { data : employeeData, isLoading, isFetching, isError, error } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    ...queryParams,
  });


  const employeeFields = employeeData?.length
    ? Object.keys(employeeData[0]).map((key) => ({
        title: key,
        dataIndex: key,
      }))
    : [];

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const MySwal = withReactContent(Swal);
  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const columns = [
    // {
    //   title: "Action",
    //   dataIndex: "action",
    //   render: (_, record) => (
    //     <div className="text-center">
    //       <Link
    //         className="action-set"
    //         to="#"
    //         data-bs-toggle="dropdown"
    //         aria-expanded="true"
    //       >
    //         <i className="fa fa-ellipsis-v" aria-hidden="true" />
    //       </Link>
    //       <ul className="dropdown-menu">
    //         <li>
    //           <Link
    //             to="#"
    //             className="dropdown-item"
    //             type="button"
    //             // onClick={() => openViewModal(record)}
    //           >
    //             <i data-feather="dollar-sign" className="info-img" />
    //             View Employee
    //           </Link>
    //         </li>
    //         <li>
    //           <Link
    //             to="#"
    //             className="dropdown-item"
    //             // onClick={() => openUpdateModal(record)}
    //           >
    //             <i data-feather="plus-circle" className="info-img" />
    //             Edit Employee
    //           </Link>
    //         </li>
    //         <li>
    //           <Link
    //             to="#"
    //             className="dropdown-item"
    //             // onClick={() => downloadStatementHandler(record)}
    //           >
    //             <i data-feather="download" className="info-img" />
    //             Login Permission
    //           </Link>
    //         </li>
    //         <li>
    //           <Link
    //             to="#"
    //             className="dropdown-item"
    //             // onClick={() => downloadStatementHandler(record)}
    //           >
    //             <i data-feather="download" className="info-img" />
    //             Reset Device ID
    //           </Link>
    //         </li>
    //         {/* <li>
    //               <Link to="#" className="dropdown-item confirm-text mb-0">
    //                 <i data-feather="trash-2" className="info-img" />
    //                 Delete Sale
    //               </Link>
    //             </li> */}
    //       </ul>
    //     </div>
    //   ),
    //   width: 100,
    // },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      width: 100,
      render: (text, record) => (
        <div className="edit-delete-action" style={{ padding: "5px" }}>
          <div className="input-block add-lists"></div>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="view-tooltip">Edit</Tooltip>}
          >
            <Link
              className="me-2 p-2"
              to={`${route.employee}${route.employee_edit}/${record.employeeCode}`}
            >
              <Edit className="feather-edit" />
            </Link>
          </OverlayTrigger>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="view-tooltip">View</Tooltip>}
          >
            <Link
              className="me-2 p-2"
              to={`${route.employee}${route.employee_view}/${record.employeeCode}`}
            >
              <Eye className="feather-view" />
            </Link>
          </OverlayTrigger>
          {/* <Link
            className="confirm-text p-2"
            to="#"
            onClick={showConfirmationAlert}
          >
            <Trash2 className="feather-trash-2" />
          </Link> */}
        </div>
      ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
    {
      title: "Image",
      dataIndex: "employeePhotoStr",
      width: 100,
      render: (text, record) => (
        <div className="employeeimgname">
          {record?.employeePhotoStr === "" ||
          record?.employeePhotoStr === null ? (
            <Link to="#" className="employee-img">
              <ImageWithBasePath
                alt=""
                src={
                  record?.gender === "M"
                    ? "assets/img/profiles/men.png"
                    : record?.gender === "F"
                    ? "assets/img/profiles/women.png"
                    : "assets/img/profiles/men.png"
                }
                width={60}
              />
            </Link>
          ) : (
            <img
              src={record?.employeePhotoStr}
              alt={record.fullName}
              width={60}
            />
          )}
        </div>
      ),
    },
    {
      title: "Emp Code",
      dataIndex: "uniqueId",
      width: 100,
    },
    {
      title: "Full Name",
      dataIndex: "fullName",
      fixed: "left",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      width: 300,
      render: (text, record) => (
        <Link
          className="me-2 p-2"
          to={`${route.employee}${route.employee_view}/${record.employeeCode}`}
        >
          {record.fullName}
        </Link>
      ),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      width: 100,
      render: (text, record) => (
        <>
          {text === "M" && <div>Male</div>}
          {text === "F" && <div>Female</div>}
          {text === "T" && <div>Trans</div>}
        </>
      ),
      sorter: (a, b) => a.gender.length - b.gender.length,
    },
    {
      title: "Department",
      dataIndex: "departmentname",
      width: 100,
      sorter: (a, b) => a.departmentname.length - b.departmentname.length,
    },
    // {
    //   title: "Designation",
    //   dataIndex: "designationName",
    //   sorter: (a, b) => a.designationName.length - b.designationName.length,
    // },
    {
      title: "Group",
      dataIndex: "groupName",
      width: 100,
      sorter: (a, b) => a.groupName.length - b.groupName.length,
    },
    // {
    //   title: "DOB",
    //   dataIndex: "dob",
    //   sorter: (a, b) => a.dob.length - b.dob.length,
    // },
    {
      title: "Contact No",
      dataIndex: "hpno",
      width: 100,
      sorter: (a, b) => a.hpno.length - b.hpno.length,
    },

    // {
    //   title: "Email",
    //   dataIndex: "email",
    //   sorter: (a, b) => a.email.length - b.email.length,
    // },

    {
      title: "Nationality",
      dataIndex: "nationality",
      width: 100,
      sorter: (a, b) => a.nationality.length - b.nationality.length,
    },

    // {
    //   title: "Employee Type",
    //   dataIndex: "employeeType",
    //   sorter: (a, b) => a.employeeType.length - b.employeeType.length,
    // },
    // {
    //   title: "Designation",
    //   dataIndex: "designation",
    //   sorter: (a, b) => a.designation.length - b.designation.length,
    // },

    {
      title: "Status",
      dataIndex: "isActive",
      width: 100,
      render: (text, record) => (
        <>
          {record.isActive === true && (
            <span className="badges badge-linesuccess">Active</span>
          )}
          {record.isActive === false && (
            <span className="badges badge-linedanger">In Active</span>
          )}
        </>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    employeeData,
    searchColumns
  );

  const { onEmployeeExcelDownload } = useTableExport({
    columns: employeeFields,
    data: filteredData,
    fileName: "Employee Details",
    pdfTheme: "",
  });

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Employees</h4>
                <h6>Manage your employees</h6>
              </div>
            </div>

            <div className="page-btn">
              <Link
                to={`${route.employee}${route.employee_add}`}
                className="btn btn-added  "
              >
                <PlusCircle className="me-2" />
                Add New Employee
              </Link>
            </div>

            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="add-new-tooltip">Import Employee</Tooltip>
                }
              >
                <Link
                  to={`${all_routes.employee}${all_routes.employee_import}`}
                  className="btn btn-secondary"
                >
                  <Download className="me-2" />
                  Import Employee
                </Link>
              </OverlayTrigger>
            </div>

            <div className="page-btn">
              <button
                className="btn btn-defalut"
                type="button"
                onClick={onEmployeeExcelDownload}
              >
                <Upload className="me-2" />
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={false}
                  />

                  <div className="total-employees">
                    <h6>
                      <Users className="me-2" />
                      Total Employees <span>{filteredData.length}</span>
                    </h6>
                  </div>

                  <div className="table-responsive">
                    <Spin spinning={isLoading || isFetching} size="large">
                      <Table
                        className="table  datanew"
                        columns={columns}
                        dataSource={filteredData}
                        scroll={{ x: "max-content", y: 600 }}
                        sticky={true}
                        rowKey={(record) => record.uniqueId || record.id}
                        pagination={true}
                      />
                    </Spin>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeMaster;
